
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Card extends Vue {
  @Prop({ default: false, type: Boolean })
  noPadding !: boolean;
}
